import React from 'react'
import {
  LoaderSwitcher,
  MerchantLocationsLoader,
  StoreOrderTypeCapacityLoader
} from 'router/Loaders'
import LocationSettings from 'components/Locations/Settings'

// Settings reads merchant locations and order-type capacity - it never
// touches modifier groups, so it deliberately doesn't mount
// MerchantModifierGroupsLoader.
export const LocationSettingsWrapper = () => {
  return (
    <MerchantLocationsLoader>
      {(isParentLoaded) => (
        <StoreOrderTypeCapacityLoader isParentLoaded={isParentLoaded}>
          {(isParentLoaded) => (
            <LoaderSwitcher isParentLoaded={isParentLoaded}>
              <LocationSettings />
            </LoaderSwitcher>
          )}
        </StoreOrderTypeCapacityLoader>
      )}
    </MerchantLocationsLoader>
  )
}
